import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

/**
 * The root renders nothing of its own. The shell lives on the `_app` layout,
 * behind the session guard, so the one screen outside it — sign-in — is not
 * wrapped in a sidebar for a user who has no session yet.
 */
export interface RouterContext {
  readonly queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
});
